__turbopack_context__.v({
  "authBox": "styles-module-scss-module__XFVM5a__authBox",
  "pageWrapper": "styles-module-scss-module__XFVM5a__pageWrapper",
  "subscriptionBox": "styles-module-scss-module__XFVM5a__subscriptionBox",
});
